<template>
  <div class="scene-module">
    <div class="main-content">
      <div class="header">
        <span class="title">覆盖直播业务全场景，满足您不同的业务需求</span>
      </div>
      <div class="scene-body">
        <div class="scene-box">
          <div class="scene-item" v-for="(item,i) in scene" :key="i">
            <img :src="item.img" alt="">
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sceneModule",
  data() {
    return {
      scene:[
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/scene-1.png",
          text: '营销直播',
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/scene-2.png",
          text: '培训直播',
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/scene-3.png",
          text: '活动直播',
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/scene-4.png",
          text: '会议直播',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.scene-module {
  background: #FFFFFF;
  width: 100%;
  min-width: 1440px;
  display: flex;
  padding: 80px 0 20px 0;
  .main-content {
    // height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .header {
      width: 100%;
      height: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 44px;
      .title {
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 48px;
        letter-spacing: 0px;
      }
    }
    .scene-body {
      width: 100%;
      display: flex;
      .scene-box{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .scene-item{
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          padding: 10px 0 24px 0;
          justify-content: space-between;
          align-items: center;
          background: #F6F9FF;
          &:hover{
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
            transition: 0.3s ease-in-out;
            transform: translateY(-5px) scale(1.1) !important;
            background: #fff;
            img{
              // transform: rotateY(180deg);
              transition: 0.5s ease-in-out;
            }
            span{
              transform: translateY(5px) ;
              transition: 0.5s ease-in-out;
            }
          }
          img{
            border-radius: 8px;
          }
          span{
            font-family: PingFang SC;
            font-size: 20px;
            font-weight: 500;
            line-height: 30px;
            letter-spacing: 0px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .main-content {
      width: 1180px;
  height: 351px;

      .header {
        .title {
          font-size: 36px;
        }
      }
      .scene-body{
        height: 259px;
              .scene-box{
                .scene-item{
          width: 280px;
          height: 225px;
          img{
            width: 260px;
            height: 179px;
          }
        }
      }
      }
    }
  }
  @media screen and (min-width: 1441px) {
    .main-content {
      width: 1420px;
  height: 392px;

      .header {
        .title {
          font-size: 40px;
        }
      }
      .scene-body{
        height: 300px;
      .scene-box{
        .scene-item{
          width: 340px;
          height: 266px;
          img{
            width: 320px;
            height: 220px;
          }
        }
      }
      }
    }
  }
}
</style>